(() => {
  function categorize(root) {
    if (root.dataset.categorized) return;
    const source = root.querySelector('.salted-description__source');
    const body = source?.querySelector('.salted-description__body');
    const labels = root.querySelector('.salted-description__labels');
    if (!body || !labels) return;
    const headings = [];
    const walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const text = node.textContent.trim();
      let category;
      if (/^Product features\s*:?$/i.test(text)) category = 'features';
      else if (/^Care instructions(?:\s*:.*)?$/i.test(text)) category = 'care';
      else if (/^Product information(?:\s*:.*)?$/i.test(text)) category = 'features';
      else if (/^Warnings,?\s*Hazard(?:\s*:.*)?$/i.test(text)) category = 'features';
      if (category) headings.push({ node, category });
    }
    const groups = new Map();
    let category = 'description';
    let previous = null;
    for (let i = 0; i <= headings.length; i++) {
      const heading = headings[i];
      const range = document.createRange();
      if (previous) range.setStart(previous, 0);
      else range.setStart(body, 0);
      if (heading) range.setEnd(heading.node, 0);
      else range.setEnd(body, body.childNodes.length);
      const fragment = range.cloneContents();
      if (fragment.textContent.trim() || fragment.querySelector('img,video,table')) {
        if (!groups.has(category)) groups.set(category, document.createDocumentFragment());
        groups.get(category).append(fragment);
      }
      if (heading) {
        previous = heading.node;
        category = heading.category;
      }
    }
    const output = document.createDocumentFragment();
    for (const [key, content] of groups) {
      const details = document.createElement('details');
      details.className = 'salted-size-chart';
      const summary = document.createElement('summary');
      summary.textContent = labels.content.querySelector('[data-key="' + key + '"]').textContent;
      const panel = document.createElement('div');
      panel.className = 'rte salted-description__body';
      panel.append(content);
      details.append(summary, panel);
      output.append(details);
    }
    // Only replace after every section has been constructed successfully.
    source.replaceWith(output);
    root.dataset.categorized = 'true';
  }
  function init(scope) {
    scope.querySelectorAll('.salted-description').forEach(categorize);
  }
  init(document);
  if (!window.saltedProductAccordionsListening) {
    document.addEventListener('shopify:section:load', event => init(event.target));
    window.saltedProductAccordionsListening = true;
  }
})();
